import { useTranslation } from 'react-i18next';

import { Jumbo } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import FeedbackRequestModals from 'packages/kakapo-ui-application/pages/feedback-v2/requests/FeedbackRequestModals';

import UserFeedbackTabs from './UserFeedbackTabs';
import UserFeedbackButtons from './UserFeedbackButtons';
import IncomingFeedbackList from './IncomingFeedbackList';
import { useRouteMatch } from 'react-router';

export default function ViewerFeedback() {
	const { t } = useTranslation();

	const { params } = useRouteMatch<{ id: string }>();
	const userID = params.id;

	const userQuery = graphql.useUserQuery({ variables: { id: userID } });

	const query = graphql.useFeedbackRequestsQuery({
		variables: { userID, last: 10, isArchived: false },
	});
	const [fetchArchived, archivedQuery] = graphql.useFeedbackRequestsLazyQuery({
		variables: { userID, last: 10, isArchived: true },
	});
	return (
		<>
			<Jumbo
				title={t('user.feedback.index.title', {
					name: userQuery.data?.user.firstName,
				})}
				button={<UserFeedbackButtons user={userQuery.data?.user as graphql.User} />}
				footer={<UserFeedbackTabs user={userQuery.data?.user as graphql.User} />}
			/>

			<IncomingFeedbackList
				query={query}
				archivedQuery={archivedQuery}
				fetchArchived={fetchArchived}
				userID={userID}
			/>

			<FeedbackRequestModals userID={userID} refetch={query.refetch} />
		</>
	);
}
